@if (!commentVisible()) {
  <button type="button" pButton (click)="displayCommentBox()">
    Add a Comment
  </button>
}
@if (commentVisible()) {
  <div>
    <div class="mb-2 flex flex-col gap-1">
      <textarea pTextarea #commentBox [(ngModel)]="commentText" rows="5"></textarea>
      <div class="flex gap-1 justify-end">
        <p-button type="button" (click)="saveComment()">Save</p-button>
        <p-button type="button" variant="outlined" (click)="hideCommentBox()">Cancel</p-button>
      </div>
    </div>
  </div>
}